import { Currency, PaymentSystem } from 'core/../react-billing/constants';

import { ProductDetails } from 'core/store/billing/selectors';

import { type PaymentMethod } from '../store/billing';

interface CreatedOrder {
  merchant: string;
  paymentIntent: string;
  signature: string;
}

export interface OrderDetails extends CreatedOrder {
  productId: string;
  products: {
    [key: string]: CreatedOrder;
  };
}

export interface PaddleConfig {
  country: string | null;
  passthrough?: string;
  paymentMethod?: string;
  checkoutId?: string;
  productId: string;
}

interface Order {
  amount: number;
  currency: Currency;
  order_id: string;
  status: string;
  subscription_id?: string;
}

export type Subscription = Omit<Purchase, 'isTrial' | 'product'>;

export interface Purchase {
  plan_name: string;
  created_at: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  amount: number;
  currency: Currency;
  isOneTimePurchase?: boolean;
  method: PaymentMethod;
  order: Order;
  paymentSystem: PaymentSystem;
  transaction_id: string;
  isTrial: boolean;
  product: ProductDetails;
  price_id: string;
  token_id?: string;
  three_d_secure_action_result_token_id?: string;
  productCode?: string;
}

export interface SubscriptionProps {
  method?: string;
  price_id?: string;
  subscription_id?: string;
  order_id?: string;
  amount?: string;
  currency?: string;
  checkout_id?: string;
  email?: string;
  paymentSystem?: PaymentSystem;
  is_sending_terminate_links?: boolean;
  three_d_secure_action_result_token_id?: string;
}

export interface CreatePayPalOrder {
  products: ProductDetails[];
  currency: Currency;
  paymentSystem?: PaymentSystem;
  trigger?: string;
  metadata?: any;
  solidMetadata?: SolidMetadata;
}

export interface SolidMetadata {
  idfm?: string;
  adjust_id?: string;
  idfv?: string;
  firebase_instance_id?: string;
  idfa?: string;
  web_uuid?: string;
}

export interface OneTimeProduct extends ProductDetails {
  product_id?: string;
  order_description?: string;
}

export const isOneTimeProductGuard = (
  product: ProductDetails | OneTimeProduct
): product is OneTimeProduct => {
  return product.isOneTimePurchase;
};
